import { gsap } from 'gsap';

export function initBusinessCase() {
  const parent = document.querySelector('.business-case');
  if (!parent) return;

  const cards = [
    ...parent.querySelectorAll('.business-case__card'),
    parent.querySelector('.business-case__tip'),
  ];

  cards.forEach((card, index) => {
    if (!card) return;

    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });

    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    });

    const nums = card.querySelectorAll('.business-case__num');
    nums.forEach((num) => {
      const to = parseInt(num.dataset.to, 10);
      tl.counter(
        num,
        {
          end: to,
          increment: 1,
          duration: 0.75,
        },
        '<',
      );
    });

    tl.to(
      card,
      {
        scale: 1,
        duration: 0.3,
        ease: 'power1.inOut',
      },
      '<+=0.5',
    );

    // Subtle continuous floating effect
    tl.to(
      card,
      {
        y: '-=3',
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: 'sine.inOut',
      },
      0,
    );
  });
}
